export const GLOBAL_LABELS = 'global';
export const ACCOUNT_LABELS = 'account';
export const CHECKOUT_LABELS = 'checkout';

// account accountOverview
export const lblOverviewMyFavoritesHeading = 'lbl_overview_myFavoritesHeading';
export const lblPlaceperkHeader = 'lbl_placeperk_header';
export const lblOverviewEarnPointsHeading = 'lbl_overview_earnPointsHeading';
export const lblOverviewMyPreferencesHeading = 'lbl_overview_myPreferencesHeading';

// account common
export const lblRnrMainTitle = 'lbl_rnr_main_title';
export const lblBiaMainTitle = 'lbl_bia_main_title';

// global accountDrawer
export const lblAccountDashboard = 'lbl_account_dashboard';
export const lblPayMyBill = 'lbl_payMyBill';
export const lblAccountDrawerLogOut = 'lbl_accountDrawer_LogOut';
export const lblApplyPlccApplyToday = 'lbl_applyPlcc_apply_today';
export const lblDrawerEarnExtra = 'lbl_drawer_earn_extra';
export const lblDrawerGetCloser = 'lbl_drawer_get_closer';
export const lblAccountDrawerPageNewWelcome = 'lbl_accountDrawerPageNew_welcome';
export const lblNewHeaderLoginAccount = 'lbl_newHeaderLogin_account';

// global trackOrder
export const lblTrackOrderHeader = 'lbl_trackOrder_header';

// global addEditAddress
export const lblAddEditAddressAddressBook = 'lbl_addEditAddress_addressBook';

// global ShopByProfile
export const lblSbpWelcomeHeader = 'lbl_sbp_welcome_header';

// checkout bagPage
export const lblCouponCollapsibleHeader = 'lbl_coupon_collapsible_header';

const AccountDrawerLabels = {
  account: {
    accountOverview: {
      [lblOverviewMyFavoritesHeading]: 'Favorites',
      [lblPlaceperkHeader]: 'My Place Rewards Status',
      [lblOverviewEarnPointsHeading]: 'Earn Extra Points',
      [lblOverviewMyPreferencesHeading]: 'Preferences',
    },
    common: {
      [lblRnrMainTitle]: 'Rate & Review',
      [lblBiaMainTitle]: 'Buy it Again',
    },
  },
  global: {
    ShopByProfile: {
      [lblSbpWelcomeHeader]: 'Welcome back, ',
    },
    addEditAddress: {
      [lblAddEditAddressAddressBook]: 'Address Book',
    },
    trackOrder: {
      [lblTrackOrderHeader]: 'Track Order',
    },
    accountDrawer: {
      [lblAccountDashboard]: 'Account Dashboard',
      [lblPayMyBill]: 'Pay My Bill',
      [lblAccountDrawerLogOut]: 'Log Out',
      [lblApplyPlccApplyToday]: 'Apply Today',
      [lblDrawerEarnExtra]: 'WANT TO EARN EXTRA POINTS?',
      [lblDrawerGetCloser]: 'Get even closer to your next Reward!',
      [lblAccountDrawerPageNewWelcome]: 'Welcome',
      [lblNewHeaderLoginAccount]: 'Account',
    },
  },
  checkout: {
    bagPage: {
      [lblCouponCollapsibleHeader]: 'Rewards & Offers',
    },
  },
};
export default AccountDrawerLabels;
